export const HEADERS_USERS_TEST_360 = [
  {
    key: 'evaluator_name',
    name: 'Evaluador',
  },
  {
    key: 'role_name',
    name: 'Rol',
  },
  {
    key: 'status',
    name: 'Estado de la evaluación',
  },
]
